module.exports = __webpack_public_path__ + "img/某企业筛选用户以提升交易额.afaa3a07.png";